import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { mapState, mapMutations } from 'vuex';
import DifficultyCard from './difficulty-card.vue';
import V3GameDifficulty from '../components/v3-game-difficulty.vue';
import { groupItemMixin, jsonGroupItemMixin } from '@/views/creative/mixin/index.js';
import ResetGameConfig from '../components/reset-game-config.vue';
import V3GameDifficultyTitle from '../components/v3-game-difficulty-title.vue';
import MultiGameDifficultyItem from './multi-game-difficulty-item.vue';

export default {
  mixins: [groupItemMixin, jsonGroupItemMixin],

  components: {
    V3GameDifficulty: V3GameDifficulty,
    DifficultyCard: DifficultyCard,
    ResetGameConfig: ResetGameConfig,
    V3GameDifficultyTitle: V3GameDifficultyTitle,
    MultiGameDifficultyItem: MultiGameDifficultyItem
  },

  data: function data() {
    return {};
  },


  computed: _extends({}, mapState({
    gameDifficultyList: function gameDifficultyList(state) {
      return state.creative.template.gameConfigResource.gameDifficultyList || null;
    },
    previewGroupConfig: function previewGroupConfig(state) {
      return state.creative.template.previewGroupConfig;
    },
    playConfig: function playConfig(state) {
      return state.creative.template.templateConfig.play_config;
    }
  }), {
    innerGameDifficultyList: function innerGameDifficultyList() {
      return (this.gameDifficultyList || []).map(function (item) {
        return _extends({}, item, {
          isDefault: false
        });
      });
    },
    previewGroupGameConfig: function previewGroupGameConfig() {
      return _.get(this.previewGroupConfig, 'game_config');
    },
    blockTagList: function blockTagList() {
      return this.innerGameDifficultyList.filter(function (item) {
        return item.tag !== '';
      }).map(function (item) {
        return item.tag;
      });
    }
  }),

  mounted: function mounted() {
    console.log('dco');
  },


  methods: _extends({}, mapMutations({
    updateGameDifficultyInGameConfigResource: 'creative/template/updateGameDifficultyInGameConfigResource'
  }), {
    handleAddValidator: function handleAddValidator(validate) {
      this.$store.commit('creative/template/addValidator', validate);
    },
    update: function update(_ref, index) {
      var conf = _ref.conf,
          key = _ref.key;

      this.updateGameDifficultyInGameConfigResource({
        key: key,
        index: index,
        value: _extends({}, conf)
      });
    },


    isEmpty: _.isEmpty
  })
};